import { ReactNode } from "react";

import { GeneralTypes } from "@/types";

const SelectedDrugTableHeaders: Array<GeneralTypes.TableHeader> = [
  {
    key: "ndc",
    label: "NDC",
  },
  {
    key: "drug_name",
    label: "Drug Name",
  },
  {
    key: "dosage_form",
    label: "Form",
  },
  {
    key: "dosage",
    label: "Dosage",
  },
  {
    key: "package_size",
    label: "Package Size",
    isSortable: false,
  },
  {
    key: "package_size_unit_of_measure",
    label: "Package Size Unit of Measure",
    isSortable: false,
  },
  {
    key: "repackaged_code",
    label: "Repackaged Code",
    isSortable: false,
  },
  {
    key: "action",
    label: "",
    formatter: (): ReactNode => {
      const component = <span aria-hidden className="caprx-icon-inputclose" />;
      return component;
    },
  },
];

export default SelectedDrugTableHeaders;
